// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";

/**
 * Nested tables (a smaller table shown inside an expanded row) use
 * Copy : XSmall : Single text and 12px/8px cell padding.
 */
export const nestedTableCellPadding = "12px 8px";

export const nestedTableFontCss = css`
    font-size: ${fontConfig.xSmallSingleLine.size}px;
    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
`;

export const nestedTableHeaderCss = css`
    ${nestedTableFontCss}
    font-weight: ${fontConfig.weight.medium};
`;

/** Applied to a DataTableRow rendered as a nested row (desktop `tr` or mobile stacked `div`). */
export const nestedTableRowCss = css`
    &&& {
        > td {
            padding: ${nestedTableCellPadding};
        }
        td,
        p,
        span,
        ${TypographyStyle} {
            ${nestedTableFontCss}
        }
    }
    &&&:not(tr) {
        padding: ${nestedTableCellPadding};
        row-gap: 12px;
    }
`;
